import { withHandlers } from 'recompose'
import { SubmissionError } from 'redux-form'
import { reduxErrorFormatter } from '../../lib/validation'

export default withHandlers({
  _handleSubmit: props => data => {
    return props.accountUpdate(data)
      .then(() => {
        props.createNotification({
          type: 'success',
          message: props.t('changes-successfully-saved')
        })
      })
      .catch(err => {
        let reduxFormErr = {
          _error: props.t('server-error')
        }
        if (err.response.status === 400) {
          reduxFormErr = {
            _error: 'form-vaidation-common-error',
            ...reduxErrorFormatter(err.response.data)
          }
        } else {
          props.createNotification({
            type: 'error',
            message: props.t('server-error')
          })
        }
        throw new SubmissionError(reduxFormErr)
      })
  }
})



// WEBPACK FOOTER //
// ./components/hoc/accountFormSubmitHandle.js